export const formatInteger = value => (value === null || value === undefined ? '-' : Number(value).toLocaleString('pt-BR'));

export const formatPercentage = value => (value === null || value === undefined ? '-' : `${Number(value).toString().replace('.', ',')}%`);

export const formatDateTime = value => (value ? new Date(value).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', ' -') : '-');
